import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  columnWrapper: { justifyContent: "space-between" },
  container: { height: "100%" },
  contentContainer: {
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 20,
    padding: 1,
    width: "48%",
  },
  contentDescription: { fontFamily: typography.primary.normal, fontSize: 11 },
  contentTitleText: { marginTop: 10, paddingHorizontal: 20, width: "80%", textAlign: "center" },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  flatList: { paddingVertical: 20 },
  flex: { flex: 1 },
  headerLogoContainer: { flexDirection: "row", justifyContent: "space-around", width: 85 },
  headerTabBarContainer: {
    alignSelf: "center",
    borderColor: colors.white,
    borderRadius: 20,
    borderWidth: 2,
    flexDirection: "row",
    height: 30,
    width: "90%",
  },
  image: {
    alignSelf: "center",
    borderRadius: 20,
    resizeMode: "cover",
  },
  imageTagContainer: {
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 1,
    position: "absolute",
    zIndex: 99,
  },
  itemTagText: { color: colors.white, fontSize: 14 },
  linearGradient: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10, paddingTop: 10 },
  selectedTabBar: {
    backgroundColor: colors.white,
    borderRadius: 30,
    margin: 1,
  },
  tabBar: { alignItems: "center", flex: 1, justifyContent: "center" },
})
